import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  MenuItem,
  DropdownButton,
  Modal,
} from 'react-bootstrap';


class BidSendMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
    };

    this.send = this.send.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
  }

  send() {
    console.log('send bid', this.state.name, this.state.email);
    this.props.sendBid(
      this.props.bid.id,
      {
        name: this.state.name,
        email: this.state.email,
        is_rebid: this.props.is_rebid
      },
    );
    this.props.close();
  }
  onNameChange(event) {
    console.log('Name is:', event.target.value);
    this.setState({ name: event.target.value });
  }
  onEmailChange(event) {
    console.log('Email is:', event.target.value);
    this.setState({ email: event.target.value });
  }
  render() {
    // No proposal send for non-branded proposals
    let contacts = null;
    if (this.props.bid.hotel.contacts) {
      contacts = this.props.bid.hotel.contacts.map(contact =>
        <li key={contact.id}>
          <strong>{contact.first_name} {contact.last_name}</strong><br />
          <span className="text-muted">{contact.email}</span>
        </li>,
      );
    }
    return (
      <Modal show={this.props.show} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Request Bid from Hotel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {contacts}
          </ul>
          <form method="post" className="send-bid">
            <input
              name="name"
              className="name"
              placeholder="Name"
              type="text"
              onChange={this.onNameChange}
            />
            <input
              name="email"
              className="email"
              placeholder="Email"
              type="text"
              onChange={this.onEmailChange}
            />
          </form>

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.send} bsStyle="info">
            <i
              className="fa fa-envelope"
              aria-hidden="true"
            /> Send</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


BidSendMenu.propTypes = {
  bid: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
};

BidSendMenu.defaultProps = {
  bid: {
    contacts: [],
  },
};
export default BidSendMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/BidSendMenu.js